import { motion } from "framer-motion";
import { Phone, Siren } from "lucide-react";
import { phoneTel } from "../../lib/constants";
import { useSettings } from "../../lib/SettingsContext";
import { Reveal } from "../Reveal";

export const Emergency = () => {
  const s = useSettings();

  return (
  <section data-testid="emergency-section" className="relative">
    <div className="hazard h-2.5 w-full" />
    <div className="bg-[#141416] py-20 relative overflow-hidden">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[500px] h-[500px] bg-red-500/10 blur-[130px] rounded-full pointer-events-none" />
      <div className="max-w-4xl mx-auto px-4 text-center relative">
        <Reveal>
          <motion.div
            animate={{ scale: [1, 1.08, 1] }}
            transition={{ duration: 1.6, repeat: Infinity, ease: "easeInOut" }}
            className="w-16 h-16 mx-auto rounded-2xl bg-red-500/15 border border-red-500/40 flex items-center justify-center mb-6"
          >
            <Siren className="w-8 h-8 text-red-500" />
          </motion.div>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-extrabold text-white leading-tight">
            {s.emergency_title}
          </h2>
          <p className="mt-4 text-lg text-zinc-400 leading-relaxed">
            {s.emergency_sub}
            <span className="text-yellow-400 font-semibold"> نجم الإطارات يأتي إليك.</span>
          </p>
          <a
            data-testid="emergency-call-btn"
            href={phoneTel(s.phone_display)}
            className="mt-8 inline-flex items-center gap-3 bg-yellow-400 text-black font-extrabold text-xl px-10 py-4 rounded-full hover:bg-yellow-300 hover:scale-[1.04] active:scale-[0.98] transition-all duration-200 shadow-[0_0_50px_rgba(255,199,0,0.35)]"
          >
            <Phone className="w-6 h-6" />
            <span dir="ltr">{s.phone_display}</span>
          </a>
          <div className="mt-4 text-sm text-zinc-500">متاحون الآن — ٢٤ ساعة، ٧ أيام في الأسبوع</div>
        </Reveal>
      </div>
    </div>
    <div className="hazard h-2.5 w-full" />
  </section>
  );
};
